import { List, Record } from 'immutable';
import FilterDefinitionTypeConstants from '~/constants/filter-definition-type-constants';
import type {
  FilterDefinitionType,
  FilterDefinitionTypeBaseFields,
} from './definitions/FilterTypeDefinitionBase';
import {
  FreeTextFilterDefinitionTypeRecord,
  RangeFilterDefinitionTypeRecord,
  SelectFilterDefinitionTypeRecord,
  TagFilterDefinitionTypeRecord,
} from './definitions';
import NameRecord from './NameRecord';

const mapFilterDefinitions = (
  filterDefinitions: FilterDefinitionTypeBaseFields[]
): FilterDefinitionType[] => {
  const mappedFilterDefinitions = filterDefinitions.map((filterDefinition) => {
    switch (filterDefinition.type) {
      case FilterDefinitionTypeConstants.MULTI_SELECT:
        return new SelectFilterDefinitionTypeRecord(filterDefinition);

      case FilterDefinitionTypeConstants.MULTI_SELECT_TAGS:
        return new TagFilterDefinitionTypeRecord(filterDefinition);

      case FilterDefinitionTypeConstants.RANGE:
        return new RangeFilterDefinitionTypeRecord(filterDefinition);

      case FilterDefinitionTypeConstants.TEXT:
        return new FreeTextFilterDefinitionTypeRecord(filterDefinition);

      default:
        return undefined;
    }
  });

  return mappedFilterDefinitions.filter(
    (f) => typeof f !== 'undefined'
  ) as FilterDefinitionType[];
};

const keys: Fields = {
  name: new NameRecord(),
  filterDefinitions: List(),
};

export interface Fields {
  filterDefinitions: List<FilterDefinitionType>;
  name: NameRecord;
}

export default class FilterSectionRecord extends Record<Fields>(keys) {
  constructor(values?) {
    super(values);

    const newValues: Partial<Fields> = {};

    if (values) {
      if (values.filterDefinitions) {
        newValues.filterDefinitions = List(
          mapFilterDefinitions(values.filterDefinitions)
        );
      }

      if (values.name) {
        newValues.name = new NameRecord(values.name);
      }
    }

    return this.merge(newValues);
  }

  getName(): string {
    return this.name.getName();
  }

  getTranslationKey(): string | undefined {
    return this.name.getTranslationKey();
  }

  getNameRecord(): NameRecord {
    return this.name;
  }

  getFilterDefinitions(): List<FilterDefinitionType> {
    return this.filterDefinitions;
  }
}
